import { create } from 'zustand'

interface SearchMenuActiveStore {
  isFocused: boolean
  setIsFocused: (isFocused: boolean) => void
}

const useSearchMenuActiveStore = create<SearchMenuActiveStore>((set) => ({
  isFocused: false,
  setIsFocused: (isFocused) => set({ isFocused }),
}))

export default useSearchMenuActiveStore
